import React from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import { Typography, Container } from "@mui/material";
import { allColors } from "../../constants";
import CardBannerSection from "./CardBanner";
import TailoredCard from "./TailoredCard";
import TailoredCardTwo from "./TailoredCardTwo";
import OurTrustPartner from "./OurTrustPartner";
import ContactForm from "../home/ContactForm";

const CardPayment = () => {
  return (
    <NavigationDrawer>
      <Container
        sx={{
          maxWidth: "1400px !important",
          marginTop: "80px",
          alignItems: "center",
        }}
      >
        <CardBannerSection />
        <TailoredCard />
        <TailoredCardTwo />
        <OurTrustPartner />
        <ContactForm />
      </Container>
    </NavigationDrawer>
  );
};

export default CardPayment;
